import { clsx } from 'clsx';
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'soft';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'sm' | 'md' | 'lg';
  icon?: ReactNode;
  iconRight?: ReactNode;
  loading?: boolean;
  block?: boolean;
  /** Faqat ikonka (kvadrat tugma) — `aria-label` majburiy. */
  iconOnly?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', icon, iconRight, loading, block, iconOnly, className, children, disabled, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={clsx(
        'kts-btn',
        `kts-btn--${variant}`,
        size !== 'md' && `kts-btn--${size}`,
        block && 'kts-btn--block',
        iconOnly && 'kts-btn--icon',
        className,
      )}
      data-loading={loading ? 'true' : undefined}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <span className="kts-spinner" style={{ width: 14, height: 14 }} /> : icon}
      {!iconOnly && children}
      {!loading && iconRight}
    </button>
  );
});

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  dot?: boolean;
  children: ReactNode;
}

/** Topbar uslubidagi yumaloq ikonka tugmasi. */
export function IconButton({ label, dot, children, className, type = 'button', ...rest }: IconButtonProps) {
  return (
    <button type={type} className={clsx('kts-icon-btn', className)} aria-label={label} title={label} {...rest}>
      {children}
      {dot && <span className="kts-icon-btn__dot" />}
    </button>
  );
}
